import { IMsTeamWithScheduleInfo } from "sh-models";
import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { TeamSetupMode } from "../store/schema/TeamSetupPickerStore";

export default mutatorAction('SET_MSTEAM_INFO', function setMSTeamInfo(
    teamWithScheduleInfo: IMsTeamWithScheduleInfo,
    setupMode: TeamSetupMode
) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.msTeamInfo = teamWithScheduleInfo.msTeamInfo;
        teamSetupPickerStore.teamSetupInfo.scheduleTeamInfo = teamWithScheduleInfo.scheduleTeamInfo;
        teamSetupPickerStore.teamSetupInfo.setupMode = setupMode;
    }
});
